export default "<div class=\"system-update\">\n  <img src=\"assets/img/system-update.png\" />\n</div>\n";